import React, { useEffect } from "react";
import HomeReviews from "../../components/homepage-components/HomeReviews";
import Faq from "../../components/universal-components/Faq";
import Hero from "../../components/Hero";
import Intro from "../../components/Intro";
import ContentLeft from "../../components/ContentLeft";
import ContentRight from "../../components/ContentRight";
import CallToAction from "../../components/CallToAction";
import { supportContent } from "../../page-content/commercial-content/supportContent";

const SupportContracts = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Hero data={supportContent} />
      <Intro data={supportContent} />
      <ContentLeft data={supportContent} />
      <ContentRight data={supportContent} />
      <CallToAction data={supportContent} />
      <HomeReviews />
      <Faq />
    </>
  );
};

export default SupportContracts;
